import React, { Component } from "react";
import TextMessage from "./TextMessage";
import FileMessage from "./FileMessage";

import "./style.scss";

class Message extends Component {
  _renderMessageOfType(type) {
    const { message } = this.props;
    switch (type) {
      case "TEXT":
        return <TextMessage {...message} />;
      case "IMAGE":
        return <FileMessage {...message} />;
      case "FILE":
        return <FileMessage {...message} />;
      default:
        return console.error(
          `Attempting to load message with unsupported file type '${type}'`
        );
    }
  }

  render() {
    const { message, locale } = this.props;
    return (
      <div className="sc-message">
        {message.author === "me" ? (
          <div
            style={{
              "--after-left": locale === "ar" ? "0" : "unset",
              "--after-right": locale === "ar" ? "unset" : "0",
            }}
            className={`${
              message.type === "TEXT" ? "text" : ""
            } sc-message--content sent`}
          >
            {this._renderMessageOfType(message.type)}
          </div>
        ) : (
          <div
            style={{
              "--after-left": locale === "ar" ? "unset" : "-1",
              "--after-right": locale === "ar" ? "-1" : "unset",
            }}
            className={`${
              message.type === "TEXT" ? "text" : " "
            } sc-message--content received`}
          >
            {this._renderMessageOfType(message.type)}
          </div>
        )}
      </div>
    );
  }
}

export default Message;
